/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: <explanation> */
"use client";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import Typography from "@/components/ui/typography";
import { getMostRepliedTopics } from "./actions";
import type { Category } from "./types";

const TopicCategoryLink = ({ category }: { category: Category }) => {
  if (category.parent) {
    return (
      <div className="flex items-center gap-2 text-[10px] leading-3.5 font-semibold text-gray-500">
        <Link
          className="hover:underline "
          href={`/forum/${category.parent.id}`}
        >
          {category.parent.name}
        </Link>
        /
        <Link
          className="hover:underline "
          href={`/forum/${category.parent.id}?category=${category.id}`}
        >
          {category.name}
        </Link>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2">
      <Link className="hover:underline " href={`/forum/${category.id}`}>
        {category.name}
      </Link>
    </div>
  );
};

const MostRepliedTopics = ({ categoryId }: { categoryId: string }) => {
  const searchParams = useSearchParams();
  const category = searchParams.get("category") ?? categoryId;

  const { data: mostRepliedTopics } = useQuery({
    enabled: !!category,
    initialData: [],
    queryFn: () => getMostRepliedTopics([categoryId, category]),
    queryKey: ["most-replied-topics", category],
  });
  return (
    <div>
      <Typography variant="sh2">En Çok Yanıtlanan Konular</Typography>
      <div className="border border-gray-300 rounded-2xl mt-2 divide-y divide-gray-300">
        {mostRepliedTopics.length > 0 ? (
          mostRepliedTopics.map((topic) => (
            <div className="p-4 flex flex-col gap-2" key={topic.id}>
              <TopicCategoryLink category={topic.category} />
              <Link
                className="font-semibold text-base leading-4"
                href={`/forum/topic/${topic.id}`}
              >
                {topic.title}
              </Link>
              <p
                className="text-sm leading-4 font-medium"
                dangerouslySetInnerHTML={{ __html: topic.text }}
              />
              <span className="bg-gray-100 w-fit px-3 py-2 rounded-full text-xs leading-4.5 font-semibold">
                {topic.replyCount} Yanıt
              </span>
            </div>
          ))
        ) : (
          <div className="px-3 py-2">Henüz hiç konu bulunmuyor.</div>
        )}
      </div>
    </div>
  );
};

export default MostRepliedTopics;
